import DOMPurify from "dompurify";

const SANITIZE_OPTIONS = {
	ALLOWED_TAGS: ["a", "b", "br", "em", "h1", "h2", "h3", "h4", "h5", "h6", "i", "li", "ol", "p", "span", "strong", "u", "ul"],
	ALLOWED_ATTR: ["class", "href", "rel", "target"],
	ALLOW_DATA_ATTR: false
};

// FAQ bodies additionally carry nested-help triggers rewritten by rewriteFaqHelpLinks. The wider allowlist stays
// scoped to that one render path so toasts, Privacy, Terms and the rest keep the strict options above.
const FAQ_SANITIZE_OPTIONS = {
	ALLOWED_TAGS: SANITIZE_OPTIONS.ALLOWED_TAGS.concat(["button"]),
	ALLOWED_ATTR: SANITIZE_OPTIONS.ALLOWED_ATTR.concat(["type", "data-faq-help-window", "data-faq-id", "data-faq-api"]),
	ALLOW_DATA_ATTR: false
};

export const sanitize = (html = "") => {
	return DOMPurify.sanitize(String(html), SANITIZE_OPTIONS);
};

export const sanitizeFaq = (html = "") => {
	return DOMPurify.sanitize(String(html), FAQ_SANITIZE_OPTIONS);
};

export const appendSanitizedHtml = (element, html = "") => {
	const sanitizedHtml = sanitize(html);
	const parser = new DOMParser();
	const parsedDoc = parser.parseFromString(`<body>${sanitizedHtml}</body>`, "text/html");

	Array.from(parsedDoc.body.childNodes).forEach((node) => {
		element.appendChild(node.cloneNode(true));
	});
};
